// extracted by mini-css-extract-plugin
module.exports = {"container":"CtaSection_container__0gMU9","title":"CtaSection_title__6nefE"};